import { route } from '@/utils/build'
const component = path => resolve => require(['@/pages/payment/views/' + path], resolve)

/**
 * 注册积分商城相关路由
 */
export default [
  route('/album-list', 'album-list', resolve => require(['@/pages/payment/views/album/index'], resolve)),
  route('/album-detail', 'album-detail', resolve => require(['@/pages/payment/views/album/detail'], resolve)),
  route('/album-paysuccess', 'album-paysuccess', resolve =>
    require(['@/pages/payment/views/album/paysuccess'], resolve)
  )
]
